import React from "react";

import LearnMore from "web_modules/shared/LearnMore";
import {
  timestampToLastUpdatedStr,
  nameToTitle,
} from "web_modules/capital_markets_dashboard/shared/utils";

import { IRateAdjusters } from "../../interfaces";
import DataMatrix, { LabelWithTooltip } from "./DataMatrix";

const styles = require("./styles.module.scss");

const ficoLtvTooltipForLoanTypes = {
  conforming:
    "Applies to GSE loans with loan amounts at or below the conforming limit of $510,400.00 where the LTV is in the displayed range AND the value of the qualifying FICO score from a successful hard credit pull is in the displayed range.",
  jumbo:
    "Applies to Jumbo loans where the LTV is in the displayed range AND the value of the qualifying FICO score from a successful hard credit pull is in the displayed range.",
  high_balance:
    "Applies to GSE loans with loan amounts above the conforming limit of $510,400.00 where the LTV is in the displayed range AND the value of the qualifying FICO score from a successful hard credit pull is in the displayed range.",
};

const renderTooltip = (loanType: string) => {
  const tooltipMsg = ficoLtvTooltipForLoanTypes[loanType];
  if (tooltipMsg) {
    return <LearnMore iconTheme="grey" text={tooltipMsg} />;
  }
  return null;
};

interface Props {
  loanTypeName: string;
  editing: boolean;
  onEdit: (val, y, x) => void;
  updatedAdjusters: IRateAdjusters;
  currentAdjusters: IRateAdjusters;
}

const FicoLtvMatrix = ({
  loanTypeName,
  editing,
  onEdit,
  updatedAdjusters,
  currentAdjusters,
}: Props) => {
  const {
    created_at,
    fico_x_ltv: { matrix, ltv, fico },
  } = updatedAdjusters;

  const firstTimeHomeBuyerLTVRange = "95.01 - 97.00%";
  let ltvWithTooltips: LabelWithTooltip = ltv;

  if (loanTypeName === "conforming") {
    ltvWithTooltips = ltv.map(l => {
      if (l === firstTimeHomeBuyerLTVRange) {
        return {
          label: l,
          tooltip:
            "Applies on primary purchase if at least one borrower has not held title on any properties in the last 3 years AND the LTV is >95.00%.",
        };
      }

      return l;
    });
  }

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>
        {nameToTitle(loanTypeName)} rate adjusters (LLPAs) for FICO/LTV
        {renderTooltip(loanTypeName)}
      </h3>

      <div className={styles.updated}>{timestampToLastUpdatedStr(created_at)}</div>
      <DataMatrix
        xAxisLabels={ltvWithTooltips}
        xAxisTitle="LTV Range"
        yAxisLabels={fico}
        yAxisTitle="FICO Range"
        prevMatrix={currentAdjusters.fico_x_ltv.matrix}
        matrix={matrix}
        editMatrix={onEdit}
        editing={editing}
      />
    </div>
  );
};

export default FicoLtvMatrix;
